import LoadingSpinner from '@/components/LoadingSpinner';
import { TbTransactionDollar } from 'react-icons/tb';
import { LeaderboardPayout, TransactionStatus } from '@repo/common-types';

const LeaderboardPayoutActions = ({
  payout,
  retryFailedPayout,
  isRetryFailedPayoutLoading,
}: {
  payout: LeaderboardPayout;
  retryFailedPayout: (txId: string) => void;
  isRetryFailedPayoutLoading: boolean;
}) => {
  return (
    <div className="d-flex gap-2">
      {payout.transaction && payout.transaction.status === TransactionStatus.FAILED && (
        <button className="btn btn-primary" onClick={() => retryFailedPayout(payout.transaction!.id)}>
          {isRetryFailedPayoutLoading ? (
            <LoadingSpinner size="16" />
          ) : (
            <div className="d-flex align-items-center gap-2">
              <TbTransactionDollar size={20} />
              Retry
            </div>
          )}
        </button>
      )}
    </div>
  );
};

export default LeaderboardPayoutActions;
